export enum MutationTypes {
  TOGGLE_DIALOG = 'TOGGLE_DIALOG',
  SET_ACTION = 'SET_ACTION',
  SET_ITEM = 'SET_ITEM',
  RESET_ITEM = 'RESET_ITEM',
  SET_LABEL = 'SET_LABEL',
  SET_TITLE = 'SET_TITLE',
  SET_TYPE = 'SET_TYPE',
  SET_ITEMS = 'SET_ITEMS',
  SET_SELECTED = 'SET_SELECTED',
  SET_NOTIFICATION = 'SET_NOTIFICATION'
}
